
import * as types from "./types";
import { JSON_STRING, HttpClient, MHTTPCL } from "../../../../services/http/http-client";
import { getNavTabModule } from "../../../../dt-plugins/sidewindow/nav-tab";

import { EOL_REACHED } from "../../../../dt-plugins/advanced-search/load.model";
import { setMainNavInactive } from "../../../../store/app/mutations";
import { licenceAccountsService } from "../../services/licence-accounts.service";
import { licenceService } from "../../services/licence.service";
import { dispatch } from "ramda-adjunct";
import router from '../../../../router';

import * as Accounttypes from "../accounts/types"
import { dtTaskService } from "../../../../dt-plugins/dt-task/dt-task-service";

const NavTabModule = getNavTabModule(types.LicenceDetails, 'licencesDetails');
export const licenceActions = {

    async [types.LicencesList.SET.ALL]({commit, getters, dispatch },payload){
      
      console.log("SET ALL LIST ACTION",payload)

      const { licence_statuses,licence_account_statuses,royalty_accounts,territories} =payload

      commit(types.LicencesList.SET.ALL, { // <-- Set the Data. Here the actual List is nested. Depends on your particular case
        ...getters.licencesList,
        licence_statuses:[...licence_statuses],
        licence_account_statuses:[...licence_account_statuses],
        royalty_accounts:[...royalty_accounts],
        territories:[...territories]
      });
    

    },

    async [types.LicencesList.UPDATE.SINGLE]({commit, getters, dispatch },payload){
      const { kVal,name,value } = payload
      const key="licence_id"
      console.log("::::::::::::::::::::value",value,"::::::::")
      if(name==="status"){
  
        const { itemID,colorPropertyName,colorPropertyValue,colorName,colorValue } = value;
  
        commit(types.LicencesList.SET.ALL, {
          ...getters.licencesList,
          licences: getters.licencesList.licences.map(e => {
            if (e.licence_id == itemID) {
              return {
                ...e,
                [colorName]: colorValue,
                [colorPropertyName]: colorPropertyValue
              }
            }
    
            return { ...e }
          }),
    
        });

        console.log("::::::::::::::::::::",{ itemID,colorPropertyName,colorPropertyValue,colorName,colorValue },"::::::::")
    
        await MHTTPCL.modifyJSON('licence_id', itemID, 'label_status_id', colorPropertyValue, 'l_licences') 
       //MHTTPCL.modify(key,itemID,'label_status_id',colorPropertyValue,"l_licences");
        //await MHTTPCL.modify(key,itemID,colorName,colorValue,"l_licence_accounts");
      }
      //else{
      //   commit(types.LicenceAccountsList.UPDATE.SINGLE,payload)
      //   await MHTTPCL.modify(key,kVal,name,value,"l_licence_accounts");
      // }
  
      
  
    },

    async [types.LicencesList.FETCH.ALL]({ commit, getters, state }, payload) {
        const { start, row_count, searchMode, basicFilter, searchFilter } = payload;
        const { searchString , active } = basicFilter
    
        let res;
    
        if (searchMode == 'none') {
          if (start == 0) {
         
          res =await HttpClient.mergeRequests([
            licenceService.licenceList(),
            //licenceService.licenceAdvancedSearchModalData()
          ]);
          
           
          console.log(res,"PPPPPPPPPPPPP")
          commit(types.LicencesList.SET.ALL,  {
            
            ...getters.licencesList,
            ...res
          } ); 
            
          //commit(types.LicencesList.SET.ALL, res);
          } else {
            // if (!(res?.data?.length > 0)) {
            //   return EOL_REACHED;
            // }
            //
            res =await licenceService.licenceList(start,row_count)
                commit(types.LicencesList.SET.ALL, {
                  ...getters.licencesList,
                  licences: [
                    ...getters.licencesList.licences,
                    ...res.data.licences,
                  ]
                });
    
            // Setting EOL
           
          }
    
        } else if (searchMode == 'basic') {
        
          
          res =await licenceService.licenceListSearch(start,row_count,active,searchString)
         
          if (start == 0) {
            commit(types.LicencesList.SET.ALL, {
              ...getters.licencesList,
              licences: res.data.licences
            });
          } else {
            commit(types.LicencesList.SET.ALL, {
              ...getters.licencesList,
              licences: [
                ...getters.licencesList.licences,
                ...res.data.licences
              ]
            });
          }
    
    
          // Setting EOL
          // if (!(res?.data?.length > 0)) {
          //   return EOL_REACHED;
          // }
        } else if (searchMode == 'advanced') {
          // console.log({ "searchFilter": searchFilter });

          const { licence_name ,licence_account, repertoire, licensor , licence_account_status_id , licence_status_id , royalty_account_id ,licence_start1 ,licence_end1,licence_start2, licence_end2, last_statement_start , last_statement_end ,territory_id } = searchFilter;

          console.log("SEARCH FILTER",searchFilter)

          res =await licenceService.licenceListAdvanceSearch(start,row_count,licence_name ,licence_account, repertoire, licensor ,licence_account_status_id , licence_status_id , royalty_account_id ,licence_start1 ,licence_end1,licence_start2, licence_end2, last_statement_start , last_statement_end ,territory_id )
          console.log("DATA",res.data);
          if (start == 0) {
            commit(types.LicencesList.SET.ALL, {
              ...getters.licencesList,
              licences: res.data.licences
            });
          } else {
            commit(types.LicencesList.SET.ALL, {
              ...getters.licencesList,
              licences: [
                ...getters.licencesList.licences,
                ...res.data.licences
              ]
            });
          }
          // Setting EOL
          // if (!(res?.data?.length > 0)) {
          //   return EOL_REACHED;
          // }
        }
      },

    // async [types.LicencesList.INSERT.SINGLE]({commit, getters, state},payload){
        
    //     console.log(payload);
    //     //const newLicence = await licenceService.addLicence({ ...payload });
 


        

    // },  

      async [types.LicenceDetails.FETCH.SINGLE]({ commit, getters, dispatch }, payload = {}) {
        const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    
        let { flag, licence, reload } = payload;
    
        flag = typeof flag === 'boolean' ? flag : true;
    
        setMainNavInactive(commit, flag);
    
        const primaryKey = 'licence_id';
        const itemName = 'licence';
        const item = payload[itemName];
    
        if (!item) {
          return;
        }
    
        const primaryKeyValue = item[primaryKey];
        const detailsGetterKey = 'licencesDetails';
        const DetailsAction = types.LicenceDetails;
    
        // Check Reload and prexisting Item Logic
        if (getters?.[detailsGetterKey]?.[primaryKeyValue] && !reload) {
          return;
        }
    
        NavTabHelper.setSingleNavTabDetails(primaryKeyValue, () => {
          return {
            [itemName]: item,
            loading: true,
          }
        })
    
        // HTTP Req
        const detailsData = await HttpClient.mergeRequests([
            licenceService.licenceDetails(licence.licence_id),
            licenceService.lcncDetailsTabOverview(licence.licence_id),
            licenceService.lcncDetailsTabTracks(licence.licence_id),
            licenceService.lcncDetailsTabIncome(licence.licence_id),
            dtTaskService.taskList(licence.licence_id,'licence')
        ]);
    
        console.log("detailsData", detailsData);
    
        NavTabHelper.setSingleNavTabDetails(primaryKeyValue, (detailsDict, licence) => {
          return {
            ...licence,
            ...detailsData,
            loading: false,
          }
        })
      },
    
      // NavItem child details
      ...NavTabModule.implementActions(
        'licence_id',
        'licences/licence_id/tab',
        'licences',
        () => router,
        'licencing',
        (value, key) => {
          return {
            title: (value && value.licence && value.licence.licence_name) ? value.licence.licence_name : key,
            full_title: (value && value.licence && value.licence.licence_name) ? value.licence.licence_name : key
          }
        }
      ),

      async [types.LicenceDetails.UPDATE.SINGLE]({ commit, getters, dispatch }, payload) {
        //console.log("types.ReleaseDetails.UPDATE.SINGLE",payload)
    
    
        const NavTabHelper = NavTabModule.Helper(dispatch, getters);
        const { name, value, item } = payload
        const { licence } = item;
        const { licence_id } = licence;
    
    
        console.log("types.ReleaseDetails.UPDATE.SINGLE", name, value, item)
        NavTabHelper.updateSingleNavTabDetails(licence_id, (licenceAccount) => {
          return {
            licence: {
              ...licenceAccount.licence,
              [name]: value,
            }
          }
        });

        const namePayload = name==='licence_label_status_id'?'label_status_id':name

        const modifiedRelease = await MHTTPCL.modifyJSON('licence_id', licence_id, namePayload, value, 'l_licences')
    
    
    
    
    
    
      },

      async [types.SET_LICENCE_RELEATED_FILES]({ dispatch, getters }, { files, externalId, externalTable }) {
        const NavTabHelper = NavTabModule.Helper(dispatch, getters);
        const licence_id = externalId;
        console.log("FIELS",files,"ID",externalId,getters.licencesDetails)
        NavTabHelper.setSingleNavTabDetails(licence_id, (_, selectedLicence) => {
          return {
            ...selectedLicence,
            files: files,
          }
        });
      },

      async [types.LicenceRelatedTracks.INSERT.SINGLE]({ commit, getters, dispatch }, payload) {
        const NavTabHelper = NavTabModule.Helper(dispatch, getters);
        const { licence_id, track_id } = payload;

        const newTrack = await licenceService.addRelatedTrack(track_id,licence_id);
        const trackListRes =await licenceService.loadRelatedTrack(licence_id);
        const royaltyAccountListRes =await licenceService.loadRelatedRoyaltyAccounts(licence_id);
        
        NavTabHelper.updateSingleNavTabDetails(licence_id, selectedLicenceDetails => {
          return {
    
            related_tracks: trackListRes.data.related_tracks,
            related_royalty_accounts:royaltyAccountListRes.data.related_royalty_accounts
            
          }
        });
  
    
      },

      async [types.LicenceRelatedAssets.INSERT.SINGLE]({ commit, getters, dispatch }, payload) {
        const NavTabHelper = NavTabModule.Helper(dispatch, getters);
        const { licence_id, external_table,external_id } = payload;

        const res = await licenceService.addLicenceAsset({...payload});
        console.log("PPPPPPPPPPPPPP",res);

        const res2 = await licenceService.lcncDetailsTabTracks(licence_id);
        console.log("PPPPPPPPPPPPPP",res2);
        NavTabHelper.updateSingleNavTabDetails(licence_id, selectedLicenceDetails => {
          return {
    
            tracks: res2.data.tracks,
            royalty_accounts:res2.data.royalty_accounts
            
          }
        });
  
    
      },



      async [types.LicenceRelatedTracks.DELETE.SINGLE]({ commit, getters, dispatch }, payload) {
        const NavTabHelper = NavTabModule.Helper(dispatch, getters);
        const { licence_id, licence_track_id } = payload;
        
        NavTabHelper.updateSingleNavTabDetails(licence_id, selectedLicenceDetails => {
          return {
    
            related_tracks: selectedLicenceDetails.related_tracks.
              filter(e => e.licence_track_id != licence_track_id)
          }
        });
    
        const deletedItem = await licenceService.removeRelatedTrack(licence_id,licence_track_id);
    
    
      },


      async [types.LicenceIncome.INSERT.SINGLE]({ commit, getters, dispatch }, payload) {
        const NavTabHelper = NavTabModule.Helper(dispatch, getters);
        const { licence_id,licence_account_id } = payload;

        const licenceLinesRes = await licenceService.lcncDetailsTabIncome(licence_id);

        console.log(payload,"licenceLinesRes",licenceLinesRes);

       



        NavTabHelper.updateSingleNavTabDetails(licence_id, selectedLicenceDetails => {
          return {
    
            licence_incomes: licenceLinesRes.data.licence_incomes,
           
            
          }
        });

        await dispatch(Accounttypes.LicenceAccountsDetails.FETCH.SINGLE,{licence_account_id:licence_account_id })

        await dispatch(Accounttypes.LicenceAccountInvoices.SET.MULTIPLE, {licence_account_id:licence_account_id });
  
    
      },

      async [types.LicenceIncome.UPDATE.SINGLE]({ commit, getters, dispatch }, payload) {
        const NavTabHelper = NavTabModule.Helper(dispatch, getters);
        const { licence_id } = payload;

        const licenceLinesRes = await licenceService.loadLicenceLines(licence_id);

        console.log("licenceLinesRes",licenceLinesRes);


        NavTabHelper.updateSingleNavTabDetails(licence_id, selectedLicenceDetails => {
          return {
    
            licence_incomes: licenceLinesRes.data.licence_lines,
           
            
          }
        });
  
    
      },

      async [types.LicenceIncome.DELETE.SINGLE]({ commit, getters, dispatch }, payload) {
        const NavTabHelper = NavTabModule.Helper(dispatch, getters);
        const { licence_id ,licence_line_id ,licence_account_id } = payload;

        //const licenceLinesRes = await licenceService.loadLicenceLines(licence_id);

        console.log("licenceLinesRes",payload);
        
      

        NavTabHelper.updateSingleNavTabDetails(licence_id, selectedLicenceDetails => {
          return {
    
            licence_incomes: selectedLicenceDetails.licence_incomes.
            filter(e => e.licence_line_id != licence_line_id)
           
            
          }
        });


        const deletedRes =  await licenceService.removeLicenceLine(licence_line_id);

        dispatch(Accounttypes.LicenceAccountInvoices.SET.MULTIPLE, {licence_account_id:licence_account_id });
  
    
      },

      // async [types.LicenceRelatedFiles.DELETE.SINGLE]({ commit, getters, dispatch }, payload) {
      //   const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    
      //   const { file_relation_id, release, file_id } = payload;
      //   const { licence_id } = release;
    
    
      //   NavTabHelper.updateSingleNavTabDetails(licence_id, selectedLicence => {
      //     return {
    
      //       related_files: selectedLicence.related_files.
      //         filter(e => e.file_relation_id != file_relation_id)
      //     }
      //   })
    
      //   const deletedLinks = await releaseService.deleteDocumentRelation(file_id, file_relation_id)
      //   //dispatch(types.FETCH_ONLY_INVOICE, { invoice });
      // },

 
}
